import React, { Component } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'lodash';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';
import { ReactSVG } from 'react-svg';
import { getSelectedProject } from '../../portfolio/selectors/portfolio';
import {
  hideCustomQuestionRightPanel, deleteCustomQuestion,
  emptyCustomQuestionBasket, deleteAutoGenratedQuestion,
  sendCustomQuestionsData,
  swapAutomatedCustomQuestion,
  removePendingCustomQuestionData,
  setCustomQuestionsBasket, isChecking,
} from '../actions/project';
import DeleteConfirmation from '../../../ui-components/DeleteConfirmation/DeleteConfirmation.jsx';
import AddCustomQuestion from '../../../ui-components/CustomQuestion/AddCustomQuestion.jsx';
import RenderIf from '../../../ui-components/Common';
import autoGeneratedQuestionSvg from '../../../../assets/images/component/svg/auto-generated-question.svg';
import customQuestionSvg from '../../../../assets/images/component/svg/custom-question.svg';
import swapQuestionActiveSvg from '../../../../assets/images/component/svg/swap-question-active.svg';
import swapQuestionSvg from '../../../../assets/images/component/svg/swap-question.svg';
import projectService from '../../../redux/services/projectService';


const mapStateToProps = state => ({
  selectedProject: getSelectedProject(state),
  customQuestionBasket: state.project.customQuestionBasket,
  userFilterGroupValues: state.project.previewRightPannel.userFilterGroupValues,
  disableSendBtn: state.project.previewRightPannel.disableSendBtn,
  userSelectedFilterGroupValues: state.project.userSelectedfilterGroupValues,
});

const mapDispatchToProps = {
  hideCustomQuestionRightPanel,
  deleteCustomQuestion,
  emptyCustomQuestionBasket,
  deleteAutoGenratedQuestion,
  sendCustomQuestionsData,
  swapAutomatedCustomQuestion,
  isChecking,
};

class PreviewCustomQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      showAddCustomQuestionModel: false,
      deleteModalTitle: 'Delete your pending questions?',
      domainId: 0,
      attributeId: 0,
      domainName: '',
      attributeName: '',
      questionModel: {},
      isSentCustomQuestions: false,
      createSegment: null,
      filterGroupId: null,
      selectedSegmentValue: '0',
      filterGroupArray: [],
      filterGroupArrayByType: [],
      associatedStakeholdersCount: null,
      userFilterGroupArray: [],
      isCustomDomain: false,
      showWarningMessage: false,
    };
    this.hideCustomQuestionRightPanel = this.hideCustomQuestionRightPanel.bind(this);
    this.deleteCustomQuestion = this.deleteCustomQuestion.bind(this);
    this.modalWrapperRef = this.modalWrapperRef.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  modalWrapperRef(node) {
    this.wrapperRef = node;
  }

  hideCustomQuestionRightPanel() {
    this.props.hideCustomQuestionRightPanel();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  deleteCustomQuestion(index, filterGroupId) {
    this.props.deleteCustomQuestion(index, filterGroupId);
    const modifiedCustomQuestionBasket = {
      projectId: this.props.selectedProject.ProjectId,
      customQuestionBasket: this.props.customQuestionBasket,
    };
    setCustomQuestionsBasket(modifiedCustomQuestionBasket);
  }

  deleteAutoGenratedQuestion(questionId, filterGroupId) {
    return new Promise((resolve) => {
      this.props.deleteAutoGenratedQuestion(questionId, filterGroupId);
      const modifiedCustomQuestionBasket = {
        projectId: this.props.selectedProject.ProjectId,
        customQuestionBasket: this.props.customQuestionBasket,
      };
      setCustomQuestionsBasket(modifiedCustomQuestionBasket);
      resolve(true);
    });
  }

  emptyCustomQuestionBasket = () => new Promise((resolve) => {
      this.props.emptyCustomQuestionBasket();
      this.props.hideCustomQuestionRightPanel();
      removePendingCustomQuestionData();
      $('.delete-alert').removeClass('hide');
      $('.delete-alert').removeClass('a-alert-hide');
      $('.delete-alert').addClass('show');
      setTimeout(() => {
        $('.delete-alert').addClass('hide');
        $('.delete-alert').addClass('a-alert-hide');
        $('.delete-alert').removeClass('show');
      }, 5000);
      resolve(true);
    })


  editCustomQuestion(model, createSegment, filterGroupId,
    selectedSegmentValue, filterGroupsValue,
    userSelectedfilterGroupValues, associatedStakeholdersCount) {
    const { userFilterGroupValues = {} } = this.props;
    const filtersValue = [];
    const {
      selectedGroupValue1 = [], selectedGroupValue2 = [],
      selectedGroupValue3 = [], selectedGroupValue4 = [],
    } = userFilterGroupValues;
    selectedGroupValue1.map((item) => {
      filtersValue.push(item);
      return item;
    });
    selectedGroupValue2.map((item) => {
      filtersValue.push(item);
      return item;
    });
    selectedGroupValue3.map((item) => {
      filtersValue.push(item);
      return item;
    });
    selectedGroupValue4.map((item) => {
      filtersValue.push(item);
      return item;
    });
    this.setState({
      questionModel: { ...model },
      domainId: model.domainId,
      attributeId: model.attributeId,
      domainName: model.domainName,
      attributeName: model.attributeName,
      createSegment,
      filterGroupId,
      selectedSegmentValue,
      filterGroupArray: filterGroupsValue,
      filterGroupArrayByType: userSelectedfilterGroupValues,
      showAddCustomQuestionModel: true,
      associatedStakeholdersCount,
      userFilterGroupArray: filtersValue,
      isCustomDomain: model.isCustomDomain,
      showWarningMessage: !model.dSegments.includes(0) && filtersValue.length > 0,
    });
  }

  openDeleteModal() {
    this.setState({ showDeleteModal: true });
  }

  cancelDelete() {
    this.setState({ showDeleteModal: false });
  }

  sendCustomQuestions() {
    this.setState({ isSentCustomQuestions: true });
    const customQuestionsData = {
      projectId: this.props.selectedProject.ProjectId,
      customQuestions: this.props.customQuestionBasket.customQuestions,
      automatedQuestions: this.props.customQuestionBasket.automatedQuestions,
    };
    this.props.sendCustomQuestionsData(customQuestionsData, true).then((result) => {
      if (result.statusText === 'OK' || result.status === 200) {
        this.props.hideCustomQuestionRightPanel();
        removePendingCustomQuestionData();
        this.setState({ isSentCustomQuestions: false });
        const valCheck = {
          value: true,
        };
        this.props.isChecking(valCheck);
        projectService.showAlert();
        setTimeout(() => {
          projectService.hideAlert();
        }, 5000);
      }
    });
  }

  swapAutomatedCustomQuestion(value, filterGroupId) {
    const noOfAutoQuestions = this.props.customQuestionBasket.automatedQuestions.reduce(
      (acc, cur) => [...acc, ...cur.questions || []], [],
    );
    const automatedQuestions = noOfAutoQuestions
      .filter(item => item.attributeId === value.attributeId);

    const questionIds = [];
    automatedQuestions.map((item) => {
      questionIds.push(item.id);
    });
    const questionModel = {
      automatedQuestionIds: questionIds,
      projectId: this.props.selectedProject.ProjectId,
      questionId: value.id,
      attributeId: value.attributeId,
      filterGroupId,
    };
    this.props.swapAutomatedCustomQuestion(questionModel);
  }

  generateAttributeBasedObj(qa) {
    let result = [];
    if (qa && qa.length > 0) {
      result = qa.map((q) => {
        if (q.questions) {
          q.totalQuestions = q.questions.length || 0;
          const questionsByAttributeId = groupBy(q.questions, 'attributeId');
          q.questionsByAttributes = [];
          Object.keys(questionsByAttributeId).map((k) => {
            const qstns = questionsByAttributeId[k];
            if (qstns.length > 0) {
              q.questionsByAttributes.push({
                attributeName: qstns[0].attributeName,
                domainName: qstns[0].domainName,
                questions: qstns,
              });
            }
          });
        }
        return q;
      });
    }
    return result;
  }

  render() {
    const { selectedProject, customQuestionBasket, userFilterGroupValues } = this.props;
    const {
      showDeleteModal, showAddCustomQuestionModel, deleteModalTitle, questionModel,
      domainId, attributeId, domainName, attributeName, isSentCustomQuestions,
      selectedSegmentValue, filterGroupArray, filterGroupArrayByType,
      associatedStakeholdersCount, createSegment, userFilterGroupArray,
      filterGroupId, isCustomDomain, showWarningMessage,
    } = this.state;

    const { customQuestions, automatedQuestions } = customQuestionBasket;
    const combinedQuestions = customQuestions.concat(automatedQuestions);

    const questionsArray = this.generateAttributeBasedObj(combinedQuestions);

    return (
      <React.Fragment >
        <RenderIf showComponent={showDeleteModal}>
          <DeleteConfirmation
            title={deleteModalTitle}
            message={['Are you sure you want to ', <span className="deletemessage-color preview-pane-font">permanently delete</span>, ` the pending questions for ${selectedProject.ProjectTitle}?`]}
            confirmationClick={this.emptyCustomQuestionBasket}
            cancelClick={() => this.setState({ showDeleteModal: false })}
          />
        </RenderIf>
        <RenderIf showComponent={showAddCustomQuestionModel}>
          <AddCustomQuestion
            projectId={selectedProject.ProjectId}
            dSegments={questionModel.dSegments}
            domainId={domainId}
            attributeId={attributeId}
            domainName={domainName}
            attributeName={attributeName}
            model={questionModel}
            customQuestionDeployed={false}
            userSelectedFilterGroupValues={this.props?.userSelectedFilterGroupValues}
            cancelClick={() => this.setState({
              showAddCustomQuestionModel: false,
            })}
            createSegment={createSegment}
            associatedStakeholdersCount={associatedStakeholdersCount}
            /* eslint-disable no-nested-ternary */
            filterGroupValues={createSegment === 'yes' ? filterGroupArray
              : (showWarningMessage ? [] : userFilterGroupArray)}
            userFilterGroupValue={createSegment === 'yes' ? filterGroupArrayByType
              : (showWarningMessage ? null : userFilterGroupValues)}
            selectedSegmentValue={selectedSegmentValue}
            filterGroupId={filterGroupId}
            isCustomDomain={isCustomDomain}
            showWarningMessage={showWarningMessage}
          />
        </RenderIf>

        <div className="right-sidebar add-project-sidebar" ref={this.props.previewCustomQuestionRef}
          style={{ zIndex: 1000 }}
        >
          <div class="right-bar">
            <div class="right-bar-head d-flex justify-content-between align-items-star">
              <div class="right-bar-title">
                <div class="header-subline"><span class="text-uppercase preview-pane-font">Pending Questions</span></div>
                <h4 class="mb-0">{selectedProject.ProjectTitle}</h4>
              </div>
              <div class="right-bar-close">
                <button type="button" className="btn btn-sm bg-transparent close" onClick={() => this.hideCustomQuestionRightPanel()}>
                  <span className="material-icons">close</span>
                </button>
              </div>
            </div>

            <div class="right-bar-body r-scroll-bar mt-3">
              <div class="rightbar-content mb-5">
                {questionsArray.length > 0 && questionsArray.map((q, i) => (
                  <React.Fragment key={i}>
                    <div class="pending-question-header">
                      <div className="pq-headings">
                        <div className="qstn-obj-cnt">
                          <span class="appkiticon icon-audience-fill mr-2"></span>
                          {q.associatedStakeholdersCount !== (undefined || null) && <span className="pq-heading-text preview-pane-font">For {q.associatedStakeholdersCount} stakeholders</span>}
                          {q.totalQuestions && q.totalQuestions > 0
                            && <div class="question-number mr-2">{`${q.totalQuestions}`}{' '}{q.totalQuestions === 1 ? 'Question' : 'Questions'}</div>}
                        </div>
                        <div className="pl-4 pt-1">
                          <ul className="segmentGroupList">
                            {q.createSegment === 'yes' && q.filterGroupValues && q.filterGroupValues.length > 0
                              && (<li key={q.filterGroupValues.join(', ')}>{q.filterGroupValues.join(', ')}</li>)}
                            {q.createSegment === 'no' && q.segmentFiltersGroup && q.segmentFiltersGroup.length > 0
                              && q.segmentFiltersGroup.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {q.questionsByAttributes && q.questionsByAttributes.length > 0
                      && q.questionsByAttributes.map((aa, index) => (
                        <div key={index}>
                          <span class="rs-section-head preview-pane-font">{aa.attributeName} ({aa.domainName})</span>
                          {aa.questions && aa.questions.map(value => (
                            <div key={index}>
                              <div class="rs-question-container">
                                <i class="icon">
                                  {
                                    value.index === undefined
                                    ? <ReactSVG src={autoGeneratedQuestionSvg} />
                                      : <ReactSVG src={customQuestionSvg} />
                                  }
                                </i>
                                <span className="quest-text align-question preview-pane-font">{value.title}</span>
                                <span className="align-question preview-pane-font">{value.type === 1 ? 'Yes/No' : 'OpenText'}</span>
                                <div class="rs-actions">

                                  {value.index !== undefined
                                    && <a href="javascript:;" className='pointer' onClick={() => this.editCustomQuestion(value, q.createSegment, q.id, q.selectedSegmentValue, q.filterGroupValues, q.userFilterGroupValues, q.associatedStakeholdersCount)}>
                                      <span className="appkiticon pointer icon-edit-outline"></span>
                                    </a>}
                                  {value.index === undefined && value.automatedQuestionCount !== undefined && value.automatedQuestionCount > 5 && <a href="javascript:;" onClick={() => this.swapAutomatedCustomQuestion(value, q.id)} className='pointer'>
                                    <ReactSVG wrapper="svg" width="15px" height="14px" src={swapQuestionActiveSvg} />
                                  </a>}
                                  {value.index === undefined && value.automatedQuestionCount !== undefined && value.automatedQuestionCount <= 5 && <a href="javascript:;" className='pointer'>
                                    <ReactSVG wrapper="svg" width="15px" height="14px" src={swapQuestionSvg} />
                                  </a>
                                  }
                                  {value.index !== undefined
                                    ? <a href="javascript:;" onClick={() => this.deleteCustomQuestion(value.index, q.id)}>
                                      <span class="appkiticon icon-delete-outline"></span>
                                    </a>
                                    : <a href="javascript:;" onClick={() => this.deleteAutoGenratedQuestion(value.id, q.id)}>
                                      <span class="appkiticon icon-delete-outline"></span>
                                    </a>
                                  }

                                </div>
                                {value.automatedQuestionCount !== undefined
                                  && value.automatedQuestionCount > 5 && <ReactTooltip id={value.title} className='swap-tooltip' place='top'
                                    effect='solid'>
                                    Swap question
                                  </ReactTooltip>}
                                {value.automatedQuestionCount !== undefined
                                  && value.automatedQuestionCount <= 5 && <ReactTooltip id={value.title} className='swap-tooltip' place='top'
                                    effect='solid'>
                                    No more question to swap
                                  </ReactTooltip>}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                  </React.Fragment>
                ))}
              </div>

            </div>
            <div className="rs-footer-buttons mt-4">
              <button type="submit" disabled={isSentCustomQuestions || this.props.disableSendBtn} onClick={() => this.sendCustomQuestions()} class="a-btn a-btn-primary a-btn-lg mr-3">Send</button>
              <button type="submit" class=" link-text" onClick={() => this.openDeleteModal()}>Delete Questions</button>
            </div>
          </div>
        </div>


      </React.Fragment >
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreviewCustomQuestions);
